<template>
  <div class="createsub-page common-bg">
    <div class="tab-bar">
      <div class="tab-btn active">单一创建</div>
    </div>

    <div class="form-section">
      <div class="form-item">
        <div class="form-label">·会员账号</div>
        <div class="input-wrap">
          <van-icon name="contact-o" size="18" color="#888" class="input-icon" />
          <input v-model="formData.username" type="text" placeholder="请输入账号" class="form-input" />
        </div>
      </div>
      <div class="form-item">
        <div class="form-label">·登录密码</div>
        <div class="input-wrap">
          <van-icon name="lock" size="18" color="#888" class="input-icon" />
          <input v-model="formData.password" :type="showPassword ? 'text' : 'password'" placeholder="请输入密码" class="form-input" />
          <van-icon :name="showPassword ? 'eye-o' : 'closed-eye'" size="18" color="#DFB372" class="eye-icon" @click="showPassword = !showPassword" />
        </div>
      </div>
      <div class="password-strength">
        <span class="strength-label">密码强度</span>
        <div class="strength-bars">
          <div class="strength-bar" v-for="i in 4" :key="i" :class="{ active: passwordStrength >= i }"></div>
        </div>
      </div>
    </div>

    <div class="bottom-btn" @click="handleCreate">
      创建直属下级
    </div>
  </div>
</template>

<script>
export default {
  name: 'promoteCreateSub',
  data() {
    return {
      formData: {
        username: '',
        password: '',
      },
      showPassword: false,
      passwordStrength: 0,
    };
  },
  watch: {
    'formData.password'(val) {
      if (val.length === 0) this.passwordStrength = 0;
      else if (val.length < 4) this.passwordStrength = 1;
      else if (val.length < 6) this.passwordStrength = 2;
      else if (val.length < 8) this.passwordStrength = 3;
      else this.passwordStrength = 4;
    },
  },
  methods: {
    handleCreate() {
      if (!this.formData.username) {
        this.$notify({ type: 'danger', message: '请输入账号' });
        return;
      }
      if (!this.formData.password) {
        this.$notify({ type: 'danger', message: '请输入密码' });
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../static/css/common.css';

.createsub-page {
  min-height: 100vh;
  background: #1E1F24;
  padding-bottom: 1.2rem;

  .tab-bar {
    padding: 0.2rem 0.15rem;

    .tab-btn {
      display: inline-block;
      padding: 0.1rem 0.3rem;
      background: #292A2C;
      border: 1px solid #3B3C3D;
      border-radius: 0.3rem;
      color: #888;
      font-size: 0.3rem;

      &.active {
        background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
        color: #333;
        border-color: #DFB372;
        font-weight: bold;
      }
    }
  }

  .form-section {
    padding: 0.2rem 0.15rem;

    .form-item {
      margin-bottom: 0.25rem;

      .form-label {
        font-size: 0.3rem;
        color: #fff;
        margin-bottom: 0.12rem;
      }

      .input-wrap {
        display: flex;
        align-items: center;
        background: #292A2C;
        border: 1px solid #3B3C3D;
        border-radius: 0.12rem;
        padding: 0 0.2rem;
        height: 0.8rem;

        .input-icon {
          flex-shrink: 0;
          margin-right: 0.12rem;
        }

        .form-input {
          flex: 1;
          background: transparent;
          border: none;
          outline: none;
          color: #fff;
          font-size: 0.3rem;

          &::placeholder {
            color: #666;
          }
        }

        .eye-icon {
          flex-shrink: 0;
          margin-left: 0.12rem;
        }
      }
    }

    .password-strength {
      display: flex;
      align-items: center;
      gap: 0.15rem;
      margin-top: 0.1rem;

      .strength-label {
        font-size: 0.3rem;
        color: #888;
      }

      .strength-bars {
        display: flex;
        gap: 0.08rem;

        .strength-bar {
          width: 0.6rem;
          height: 0.08rem;
          background: #3B3C3D;
          border-radius: 0.04rem;

          &.active {
            background: #DFB372;
          }
        }
      }
    }
  }

  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0.2rem 0.15rem;
    padding: 0.28rem 0;
    background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
    border-radius: 0.5rem;
    text-align: center;
    font-size: 0.35rem;
    color: #333;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component/promote/CreateSub.vue